import React from 'react'
import CekHargaPage from '../../modules/cekharga/CekargaaPage'

export default function CekHarga() {
    return (
        <div><CekHargaPage /></div>
    )
}
